import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  ViewEncapsulation,
} from '@angular/core';
import { Conversation, ConversationType } from '@clientwire/api';
import { HandlebarPipe, SafeHtmlPipe } from '../../../pipes';

@Component({
  selector: 'shared-conversation-header',
  standalone: true,
  imports: [HandlebarPipe, SafeHtmlPipe],
  templateUrl: './conversation-header.component.html',
  styleUrl: './conversation-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    '[class.active]': 'isActive()',
  },
})
export class ConversationHeaderComponent {
  isActive = input<boolean | undefined>(false);
  conversationType = input<ConversationType | undefined>();
  conversation = input<Conversation>();

  templateData = computed(() => {
    const conversationValue = this.conversation();
    if (!conversationValue) return undefined;

    let templateDataValue = conversationValue.templateData;
    if (!templateDataValue) return undefined;
    const value =
      conversationValue.readStatus?.unreadMessageCount ??
      templateDataValue.listItem?.['conversation.unread_count'];

    if (templateDataValue.listItem && typeof templateDataValue.listItem === 'object') {
      for (const key of Object.keys(templateDataValue.listItem)) {
        const val = templateDataValue.listItem[key];
        if (Array.isArray(val) && val.length > 0) {
          templateDataValue.listItem[key] =
            `${val[0]}${val.length > 1 ? ` (+${val.length - 1})` : ''}`;
        }
      }
    }
    return {
      ...templateDataValue.listItem,
      'conversation.unread_count': value,
    };
  });
}
